(function () {
    'use strict';

    var module = angular.module('uwAgenda.agenda');

    // click-directive to show info about patient and appointment 
    module.directive('agendaAppointmentShow', ['AppointmentDetailService', function (AppointmentDetailService) {
        var directive = {
            link: link,
            restrict: 'A',
            scope: {
                id: '=', // appointment id
                agendaId: '='
            }
        };
        return directive;

        function link(scope, element) {

            // click listener
            element.on('click', function () {
                show();
            });

            // show info
            function show() {
                AppointmentDetailService.show(scope.id, scope.agendaId);
            } // show

            // on destroy
            scope.$on("$destroy", function () {
                element.off("click");
            });

        }
    }]);

})();